import "../css/header.css";
import "../css/App.css";
import fcLogo from "../images/fcLogo.png";

function Header() {
  return (
    <header className="App-header">
      <img src={fcLogo} alt="First Class Home Mortgage Logo" className="topLogo" />
    </header>
  );
}

export default Header;
